import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { registerPwaPageHideCapture, tryRestoreSpaPathAfterPwaReload } from '@/lib/pwaRoutePersistence';
import { applyPwaThemeToDocument, readStoredPwaTheme } from '@/lib/pwaTheme';
import './index.css';
import App from './App.tsx';

applyPwaThemeToDocument(readStoredPwaTheme());

registerPwaPageHideCapture();
tryRestoreSpaPathAfterPwaReload();

const updateSW = registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    const check = () => {
      void registration.update();
    };
    check();
    window.setInterval(check, 60_000);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check();
    });
  },
  onNeedRefresh() {
    void updateSW(true);
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
